import React, { PureComponent, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { BellOutlined } from '@ant-design/icons';
import { Tabs, Badge, Spin, Tag, Radio } from 'antd';
import classNames from 'classnames';
import { connect } from 'dva';
import HeaderDropdown from '../HeaderDropdown';
import List from './NoticeList';
import styles from './index.less';
import { groupBy } from '../../utils/utils';
import emptyImage from '../../assets/emptyImage.svg';
const { TabPane } = Tabs;

@connect(({ notifications, user, organisation }) => ({
  notifications: notifications.list,
  lastVisible: notifications.lastVisible,
  loadingMore: notifications.loadingMore,
  user: user.currentUser,
  organisation: organisation.current,
}))
export default class NoticeIcon extends PureComponent {
  static Tab = TabPane;

  static defaultProps = {
    onItemClick: () => {},
    onPopupVisibleChange: () => {},
    onTabChange: () => {},
    onClear: () => {},
    onViewMore: () => {},
    loading: false,
    clearClose: false,
    locale: {
      emptyText: 'No notifications',
      clear: 'Clear',
      viewMore: 'More',
    },
  };

  state = {
    visible: false,
    filterSeverity: '',
    tabType: 'risk',
  };

  onItemClick = (item, tabProps) => {
    const { onItemClick } = this.props;
    const { clickClose } = item;
    this.setState({
      visible: false,
    });
    onItemClick(item, tabProps);
    if (clickClose) {
      this.popover.click();
    }
  };

  onClear = name => {
    const { onClear, clearClose } = this.props;
    onClear(name);
    if (clearClose) {
      this.popover.click();
    }
  };

  onTabChange = tabType => {
    /**
     * tabTypeCopy is added because i was calling this func from clickNotification
     */
    let tabTypeCopy = tabType;
    tabType = tabType.split('/')[1];

    const { onTabChange, dispatch, organisation } = this.props;
    if (tabType === '.1' || tabTypeCopy === 'info') {
      this.setState({
        tabType: 'info',
      });
      dispatch({
        type: 'user/resetUnreadCount',
        payload: {
          type: 'system',
          organisation: organisation.id,
        },
      });
    } else {
      this.setState({
        tabType: 'risk',
      });
      dispatch({
        type: 'user/resetUnreadCount',
        payload: {
          type: 'risk',
          organisation: organisation.id,
        },
      });
    }
    onTabChange(tabType);
  };

  onViewMore = (tabProps, event) => {
    const { onViewMore } = this.props;
    onViewMore(tabProps, event);
  };

  filter(val) {
    const { tabType } = this.state;
    this.setState({
      filterSeverity: val,
    });
  }

  getNotificationBox() {
    const { children, loading, locale, user } = this.props;

    if (user && user.hasOwnProperty('alertsCount')) {
      let { alertsCount } = user;
      let risksCount = alertsCount.risks;
      let systemCount = alertsCount.systems;
    } else {
    }
    if (!children) {
      return null;
    }
    const panes = React.Children.map(children, child => {
      let { list, title, count, emptyText, showClear, showViewMore } = child.props;

      let { filterSeverity } = this.state;

      let msgCount;
      const localeTitle = locale[title] || title;

      const tabTitle = localeTitle;

      return (
        <TabPane tab={tabTitle} key={title}>
          <List
            loadingMore={this.props.loadingMore}
            clickNotification={this.clickNotification}
            data={list}
            lastVisible={this.props.lastVisible}
            emptyImage={emptyImage}
            emptyText={emptyText}
            locale={locale}
            onClear={() => this.onClear(title)}
            onClick={item => this.onItemClick(item, child.props)}
            onViewMore={event => this.onViewMore(child.props, event)}
            showClear={showClear}
            showViewMore={showViewMore}
            title={title}
          />
        </TabPane>
      );
    });
    const filterTab = ['All', 'High', 'Medium', 'Low'];
    const { tabType } = this.state;
    return (
      <Fragment>
        <Spin spinning={loading} delay={0}>
          <Tabs
            className={styles.tabs}
            onChange={this.onTabChange}
            tabBarExtraContent={
              <div>
                {tabType === 'risk' ? (
                  <Radio.Group defaultValue="All" style={{ marginRight: '22px' }} size="small">
                    {filterTab.map(val => (
                      <Radio.Button value={val} key={val} onClick={() => this.filter(val)}>
                        <div style={{ fontSize: '12px' }}>{val}</div>
                      </Radio.Button>
                    ))}
                  </Radio.Group>
                ) : (
                  ''
                )}
              </div>
            }
          >
            {panes}
          </Tabs>
        </Spin>
      </Fragment>
    );
  }

  handleVisibleChange = visible => {
    const { onPopupVisibleChange } = this.props;
    this.setState({ visible });
    onPopupVisibleChange(visible);
  };

  componentDidUpdate(prevProps, prevState) {
    const { dispatch, user, organisation } = this.props;

    if (
      prevState.tabType !== this.state.tabType ||
      prevState.filterSeverity !== this.state.filterSeverity
    ) {
      this.clickNotification(false);
    }

    if (prevState.visible !== this.state.visible && this.state.visible === false) {
      dispatch({
        type: 'user/resetUnreadCount',
        payload: {
          type: 'risk',
        },
      });
    }

    if (
      prevState.organisation !== this.state.organisation &&
      this.state.organisation === undefined
    ) {
      let { tabType, filterSeverity } = this.state;

      dispatch({
        type: 'notifications/list',
        payload: {
          params: {
            userId: user.id,
            severity: tabType === 'risk' ? filterSeverity : '',
            limit: 20,
            type: tabType,
            orgId: organisation?.id,
          },
        },
      });
    }
  }

  clickNotification = (params, isMore) => {
    let { tabType, filterSeverity } = this.state;
    // i have added this to clear notification count
    this.onTabChange(tabType);
    if (filterSeverity === 'All') {
      filterSeverity = '';
    }
    filterSeverity = filterSeverity.toLowerCase();
    if (params === false) {
      let { dispatch, user, lastVisible, organisation } = this.props;
      if (isMore && isMore === 'moreList') {
        if (lastVisible) {
          dispatch({
            type: 'notifications/moreList',
            payload: {
              params: {
                userId: user.id,
                limit: 20,
                severity: tabType === 'risk' ? filterSeverity : '',
                type: tabType,
                orgId: organisation?.id,
              },
            },
          });
        } else {
        }
      } else {
        dispatch({
          type: 'notifications/list',
          payload: {
            params: {
              userId: user.id,
              severity: tabType === 'risk' ? filterSeverity : '',
              limit: 20,
              type: tabType,
              orgId: organisation?.id,
            },
          },
        });
      }
    } else {
      const { dispatch } = this.props;
      dispatch({
        type: 'user/resetUnreadCount',
        payload: {
          type: 'risk',
        },
      });
    }
  };

  render() {
    const { className, count, popupVisible, bell } = this.props;
    const { visible, list } = this.state;

    const noticeButtonClass = classNames(className, styles.noticeButton);
    const notificationBox = this.getNotificationBox();
    const NoticeBellIcon = bell || (
      <BellOutlined
        className={styles.icon}
        style={{ fontSize: 20 }}
        onClick={() => this.clickNotification(visible)}
      />
    );
    const trigger = (
      <span className={classNames(noticeButtonClass, { opened: visible })}>
        <Badge
          count={count}
          overflowCount={1000}
          style={{ boxShadow: 'none', backgroundColor: 'red' }}
          className={styles.badge}
        >
          {NoticeBellIcon}
        </Badge>
      </span>
    );
    if (!notificationBox) {
      return trigger;
    }
    const popoverProps = {};
    if ('popupVisible' in this.props) {
      popoverProps.visible = popupVisible;
    }
    return (
      <HeaderDropdown
        placement="bottomRight"
        tabBarGutter={0}
        overlay={notificationBox}
        overlayClassName={styles.popover}
        trigger={['click']}
        visible={visible}
        onVisibleChange={this.handleVisibleChange}
        {...popoverProps}
        ref={node => (this.popover = ReactDOM.findDOMNode(node))} // eslint-disable-line
      >
        {trigger}
      </HeaderDropdown>
    );
  }
}
